import { createSelector } from '@reduxjs/toolkit';
import { calendarTaskInstances } from './calendar-task-instances';
import { todoList } from './todo-list';
import { LocalDate } from '../../../utilities/local-date';
import type { CalendarDayTask } from './calendar-day-task';

/**
 * Returns the number of undone todoitems plus events and meeting for the rest of the week, for current employee
 */
export const currentWeekRemainingTasksAndMeetingsForEmployee = createSelector(
  calendarTaskInstances,
  todoList,
  (tasks, todo): number => {
    const today = LocalDate.now();
    const remainingDatedTasksAndMeetings: CalendarDayTask[] = [];
    tasks.forEach((day) => {
      day.tasks.forEach((task) => {
        if (
          task.myTask &&
          !task.doneDate &&
          (LocalDate.fromString(task.dateTimeForOrdering).isSameOrAfter(today) || task.persistent)
        ) {
          remainingDatedTasksAndMeetings.push(task);
        }
      });
    });
    const remainingTodoTasks = todo.filter((t) => {
      return t.myTask && !t.doneDate;
    });
    return remainingDatedTasksAndMeetings.length + remainingTodoTasks.length;
  },
);
